import React from 'react'
import cx from 'classnames'
import { compose, lifecycle, withState } from 'recompose'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Link } from 'react-router'
import { UpgradeModal } from '@driftt/billing-components'

import ACCESS from 'utils/Access'
import { Skill, Button } from '@driftt/tide-core-legacy'
import { ColorWay, Icon } from '@driftt/tide-core'
import { SectionItem } from 'components/shared/Section'
import MeetingTaskConfig from './MeetingTaskConfig'

import { assistantAgentSettings } from 'app/modules/assistantSettings/selectors'
import { fetchAssistantAgentSettings } from 'app/modules/assistantSettings/actions'
import { isOauthConnected } from 'app/modules/meetings/selectors'
import { hasProPlan } from 'app/modules/gates/selectors'
import { fetchIntegrationStates } from 'app/modules/integrations/actions'
import { isConnectedTo } from 'app/modules/integrations/selectors'

import IntegrationConnector from 'components/Integration/components/IntegrationConnector'

import { SALESFORCE_AUTH_URL, SALESFORCE_PAYLOAD } from 'constants/ResourcesConstants'

import ConfirmDefaultConfigurationModal from './MeetingTaskConfig/ConfirmDefaultConfigurationModal'

import {
  fetchCalendarStatus,
} from 'app/modules/meetings/actions'

import { patchOrgProperties } from 'app/modules/org/actions'

import './style.styl'
import 'styles/components/settings/Settings.styl'

const MeetingPrepSVG = require('!svg-inline?removeSVGTagAttrs=true!images/assistant-config/meeting-prep-skill.svg')
const FollowUpSVG = require('!svg-inline?removeSVGTagAttrs=true!images/assistant-config/follow-up-skill.svg')

const SkillsComponents = [
  {
    skillName: 'Be prepared for every meeting',
    subHead: `Before every meeting, you'll get an email of everything you need to know, including any prior history, context on previous conversations, and notes on recent website activity.`,
    canOpen: true,
    settingName: 'MEETING_PREP',
    hasTemplate: false,
    headerIcon: () => <ColorWay type="1"><Icon name="cw-reminder"/></ColorWay>,
    component: MeetingTaskConfig,
    hasStatusBadge: true,
  },
  {
    skillName: 'Never forget to follow-up with a cancellation',
    subHead:
      'When someone cancels a meeting, Drift Assistant will remind you to reach out and keep them warm, so you don’t have to spend your days chasing them down to reschedule.',
    canOpen: true,
    settingName: 'MEETING_CANCELLED',
    hasTemplate: true,
    headerIcon: () => <ColorWay type="2"><Icon name="cw-be-prepared"/></ColorWay>,
    component: MeetingTaskConfig,
    hasStatusBadge: true,
  },
  {
    skillName: 'Always remember to send next steps',
    subHead:
      'The Drift Assistant will make sure none of your potential customers fall through the cracks. If you forget to send next steps after a demo, the assistant will remind you.',
    canOpen: true,
    settingName: 'DEMO_FOLLOW_UP',
    hasTemplate: true,
    headerIcon: () => <ColorWay type="4"><Icon name="cw-be-prepared"/></ColorWay>,
    component: MeetingTaskConfig,
    hasStatusBadge: true,
  },
]



const SFNotConnectedSkills = [SkillsComponents[1], SkillsComponents[2]]

class AssistantConfig extends React.Component {
  render() {
    const {
      salesforceAvailable,
      isSalesforceConnected,
      isCalendarConnected,
      isUpgradeModalOpen,
      setUpgradeModal,
      isConfirmDefaultModalOpen,
      setConfirmDefaultModal,
      assistantAgentSettings,
      actions,
    } = this.props

    const salesforceConnectButton = (
      <IntegrationConnector
        onIntegrationConnected={() => {
          actions.fetchIntegrationStates()
          setConfirmDefaultModal(true)
        }}
        integrationId="salesforce"
        isOauth={true}
        oauthLink={SALESFORCE_AUTH_URL}
        title="Connect Salesforce"
        connectorType="button"
        buttonType="primary"
        className="salesforce-integration-connector"
        oauthQueryParams={SALESFORCE_PAYLOAD}
      />
    )

    const isAdmin = ACCESS.isAdmin()

    const AssistantHeader = <div className="assistant-config-header">
       <div className="setting-page-title">
         <p className="page-description">
             The Drift Assistant helps you close more deals by preparing you for your meetings and sending you
             reminders for important deals so you never accidentally lose an opportunity again.
                 <a href="https://help.drift.com/article/drift-assistant-basics/?v=1536180632162" target="_blank" rel="noreferrer noopener">
               {' '}
               Learn more.
                 </a>
           </p>
       </div>

    </div>

    const AdminConnectMeeting = (
      <div className={cx('assistant-calendar-connect-state is-admin', { 'sf-not-connected': !isSalesforceConnected })}>
        <div className="connect-helper-text-container">
          <div className="left">Connect your calendar to the Drift Assistant</div>
          <div className="right">
            <Button type="secondary" href="/meetings/?source=assistant">
              Connect Calendar
            </Button>
          </div>
        </div>
      </div>
    )

    const ConnectCalendar =
      isAdmin && salesforceAvailable ? (
        AdminConnectMeeting
      ) : (
        <div className="assistant-config-header calendar-connect">
          <div className="assistant-calendar-connect-state">
            <div className="connect-header">
              <Icon height={30} name="bot" width={30} />
              <p>Step 1: Connect your Calendar to your Drift Assistant</p>
            </div>
            <div className="gradient-line" />
            <div className="connect-helper-text-container">
              <div className="left">
                The Drift Assistant helps you close more deals with less work. It prepares your team for meetings
                and sends reminders so you never accidentally lose a lead or an opportunity again.
              </div>
              <div className="right">
                <Button className="gradient-connect-calendar" type="subtle" href="/meetings/?source=assistant">
                  Connect Calendar
                </Button>
              </div>
            </div>
          </div>
        </div>
      )

    const FullSkills = SkillsComponents.map((skillsProps, i) => {
      const skillProps = { ...skillsProps, canOpen: isCalendarConnected, hasStatusBadge: isCalendarConnected, isOn: assistantAgentSettings.getIn([skillsProps.settingName, 'on']) }
      return <Skill {...skillProps} key={`skill-${i}`} />
    })

    const SFNotConnected = SFNotConnectedSkills.map((skillsProps, i) => {
      const skillProps = { ...skillsProps, canOpen: false, hasStatusBadge: false }
      return <Skill {...skillProps} key={`skill-${i}`} />
    })

    const SFNotConnectedComponent = <div>
      <div className={cx('not-connected', { 'sf-not-connected': !isSalesforceConnected, 'is-admin': isAdmin, 'sf-available': salesforceAvailable })}>
        {
          !isAdmin
            ? <div className="connect-salesforce">
                <div className="left">To enable the assistant’s skills below, ask a Drift Admin to connect your team’s Salesforce account. <a href="https://app.drift.com/help/article/drift-assistant-basics">Learn More</a></div>

                {/* <div className="right"><Button>Ask an Admin</Button></div> TODO: implement email button later */}
              </div>
            : salesforceAvailable
              ? <div className="missing-out">
                  <h3 className="missing-out-header">Without Salesforce, here’s what your team is missing out on:</h3>
                </div>
              : <div className="salesforce-upgrade" onClick={() => setUpgradeModal(true)}>
                  <div className="helper-text">To enable the tasks below, you need to have Salesforce connected. Upgrade your plan to get access to the Salesforce Integration!</div>
                  <div className="PremiumOverlay__Banner">Upgrade</div>
                </div>
        }

        {SFNotConnected}
      </div>
    </div>


    const ConnectSalesforce = <div className="assistant-config-header calendar-salesforce">
      <div className="assistant-calendar-connect-state">
        <div className="connect-header">
          <p>Connect Salesforce to the Drift Assistant</p>
        </div>
        <div className="connect-helper-text-container">
          <div className="left">The Drift Assistant prepares your team for meetings and sends reminders so they never accidentally lose a lead or an opportunity again. <a className="learn-more" href="https://help.drift.com/article/drift-assistant-basics/?v=1536180632162" target="_blank" rel="noreferrer noopener">
          {' '}
          Learn more
            </a></div>
          <div className="right">
            {salesforceConnectButton}
          </div>
        </div>
      </div>
    </div>

    const AdminSalesforceNotConnected = <div style={{ marginTop: "60px" }}>
      {salesforceAvailable && ConnectSalesforce}
      {SFNotConnectedComponent}
    </div>

    const AdminMeetingPrep = <div className={cx({ 'admin-meeting-prep-on-top': isCalendarConnected, 'admin-meeting-not-connected': !isCalendarConnected })}>
      {!isCalendarConnected && AdminConnectMeeting}
        <Skill {...SkillsComponents[0]} canOpen={isCalendarConnected} key={`skill-0`} isOn={assistantAgentSettings.getIn([SkillsComponents[0].settingName, 'on'])} />
      </div>

    const AdminComponents = [
      AdminMeetingPrep,
      AdminSalesforceNotConnected,
    ]

    const RepComponents = [
      !isCalendarConnected && ConnectCalendar,
      <div className={cx({ 'not-connected calendar-not-connected': !isCalendarConnected, 'not-admin': !isAdmin })}>
        {!isCalendarConnected && <div className="missing-out">
          <h3 className="missing-out-header">Here’s what you’re missing out on:</h3>
        </div>}
        {!isCalendarConnected || isSalesforceConnected
          ? FullSkills
          : [<Skill {...SkillsComponents[0]} key={`skill-0`} isOn={assistantAgentSettings.getIn([SkillsComponents[0].settingName, 'on'])} />, SFNotConnectedComponent]}
      </div>,
    ]

    return (
      <div>
        { isAdmin
            ? (isCalendarConnected || isSalesforceConnected) && AssistantHeader
            : isCalendarConnected && AssistantHeader
        }
        {
          isAdmin &&
          isSalesforceConnected && (
            <SectionItem
              title="The Drift Assistant is configured for your team"
              description="Make sure your team never lets a lead or opportunity fall through the cracks again. Help your team succeed by configuring the Drift Assistant to remind them about only their most important deals."
              className="assistant-config-footer-section"
            >
              <Link to="/settings/assistant/org">Customize Drift Assistant Configuration</Link>
            </SectionItem>
          )
        }
        {
          isAdmin && salesforceAvailable && !(salesforceAvailable && isSalesforceConnected)
            ? AdminComponents
            : RepComponents
        }
        { isUpgradeModalOpen &&
            <UpgradeModal
              onCloseInitiated={() => setUpgradeModal(false)}
              headLineFeatureText={'Drift Assistant Salesforce Skills'}
              planName={'Pro'}
              isMonthlyBilling={true}
              />
        }
        {
          isConfirmDefaultModalOpen &&
          <ConfirmDefaultConfigurationModal
            onSave={() => {
              actions.patchOrgProperties([
                {
                  "operation": "set",
                  "property": "hasCustomizedAssistantSFDCActivity",
                  "value": true
                },
                {
                  "operation": "set",
                  "property": "hasCustomizedAssistantSFDCMapping",
                  "value": true
                }
              ])
              setConfirmDefaultModal(false)
            }}
            onCancel={() => setConfirmDefaultModal(false)}
          />

        }

      </div>
    )
  }
}

const mapStateToProps = state => ({
  salesforceAvailable: hasProPlan(state),
  isSalesforceConnected: isConnectedTo(state, 'salesforce'),
  isCalendarConnected: isOauthConnected(state),
  assistantAgentSettings: assistantAgentSettings(state),
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      fetchAssistantAgentSettings,
      fetchCalendarStatus,
      patchOrgProperties,
      fetchIntegrationStates
    },
    dispatch
  ),
})

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withState('isUpgradeModalOpen', 'setUpgradeModal', false),
  withState('isConfirmDefaultModalOpen', 'setConfirmDefaultModal', false),
  lifecycle({
    componentDidMount() {
      const { actions } = this.props
      actions.fetchCalendarStatus()
      actions.fetchIntegrationStates()
      actions.fetchAssistantAgentSettings()
    },
  })
)(AssistantConfig)



// WEBPACK FOOTER //
// ./src/scripts/components/settings/AssistantConfig/index.js